import Vue from 'vue'
import Element from 'element-ui'
import App from '@/App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/icons'
import '@/element-ui/theme/index.css'
import '@/assets/scss/aui.scss'
import http from '@/utils/request'
import { getConfigKey, updateConfigByKey } from "@/api/system/config";
import renRadioGroup from '@/components/ren-radio-group'
import renSelect from '@/components/ren-select'
import renDeptTree from '@/components/ren-dept-tree'
import renRegionTree from '@/components/ren-region-tree'
import { download } from '@/utils/request-ruoyi'
import { formatStatus } from '@/utils/helper'
// Sentry 错误监控
// import { initSentry } from '@/utils/sentry'
// 文件上传组件
import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
import ImagePreviewWithUpload from "@/components/ImagePreviewWithUpload"
import ImagePreviewWithUploadOld from "@/components/ImagePreviewWithUploadOld"
// 分页组件
import Pagination from "@/components/Pagination";
import RightToolbar from '@/components/RightToolbar'
import { hasPermission, getDictLabel } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
import plugins from './plugins' // plugins
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";

Vue.config.productionTip = false

// 初始化 Sentry 错误监控
// initSentry(Vue, router, store)




Vue.use(Element, {
  // Element 只接受 medium / small / mini，传 'default' 等同于不设置，
  // 会让所有组件用最大尺寸（按钮、输入框高 40px），后台页面显得过于臃肿
  size: 'small',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(plugins)
Vue.use(renRadioGroup)
Vue.use(renSelect)
Vue.use(renDeptTree)
Vue.use(renRegionTree)

Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('ImagePreviewWithUpload', ImagePreviewWithUpload)
Vue.component('ImagePreviewWithUploadOld', ImagePreviewWithUploadOld)
// 挂载全局
Vue.prototype.$http = http
Vue.prototype.parseTime=parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.updateConfigByKey = updateConfigByKey
Vue.prototype.download = download
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$getDictLabel = getDictLabel
Vue.prototype.formatStatus= formatStatus
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
